export default __webpack_public_path__ + "static/media/pptls.4f5a5391.png";